@if (legacyId) {
  <div class="margin-right legacy-id" matTooltip="Legacy ID" matTooltipPosition="above">
    <span><mat-icon>folder_open</mat-icon></span
    >{{ legacyId }}
  </div>
}
